export default __webpack_public_path__ + "static/media/FoodAndBeverageBackground1024x683.305cedae.png";